

export enum InvoiceMode {
    IN_PROCESS = 1,
    DONE = 2,
    CANCELED = 3
}

export function isInvoiceMutationAllowed( invoiceModeId: number ): boolean {
    switch( invoiceModeId ) {
        case InvoiceMode.IN_PROCESS:
            return true;
        case InvoiceMode.DONE:
        case InvoiceMode.CANCELED:
            return false;
    }

    throw Error("invoice mode not found!");
}

export function invoiceModeFromNumber( invoiceModeId: number ): InvoiceMode {
    switch( invoiceModeId ) {
        case InvoiceMode.IN_PROCESS:
            return InvoiceMode.IN_PROCESS;
        case InvoiceMode.DONE:
            return InvoiceMode.DONE;
        case InvoiceMode.CANCELED:
            return InvoiceMode.CANCELED;
    }

    throw Error("invoicemode not found!")
}